
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Phone, Mail, Clock } from 'lucide-react';

interface HelpSupportDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  supportPhone: string;
  supportEmail: string;
  supportHours: string;
}

const HelpSupportDialog = ({
  open,
  onOpenChange,
  supportPhone,
  supportEmail,
  supportHours,
}: HelpSupportDialogProps) => {
  const handleCallSupport = () => {
    window.location.href = `tel:${supportPhone}`;
  };

  const handleEmailSupport = () => {
    window.location.href = `mailto:${supportEmail}`;
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Help & Support</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="text-center">
            <p className="text-gray-600 mb-6">
              Need help? Contact our support team
            </p>
          </div>

          {/* Phone Support */}
          <div className="space-y-3">
            <Button
              onClick={handleCallSupport}
              className="w-full flex items-center justify-center gap-3 bg-green-600 hover:bg-green-700"
            >
              <Phone className="h-5 w-5" />
              Call Support
            </Button>
            <p className="text-center text-sm text-gray-600">{supportPhone}</p>
          </div>

          {/* Email Support */}
          <div className="space-y-3">
            <Button
              onClick={handleEmailSupport}
              variant="outline"
              className="w-full flex items-center justify-center gap-3"
            >
              <Mail className="h-5 w-5" />
              Email Support
            </Button>
            <p className="text-center text-sm text-gray-600">{supportEmail}</p>
          </div>

          {/* Business Hours */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Clock className="h-4 w-4 text-gray-600" />
              <span className="font-medium text-sm">Support Hours</span>
            </div>
            <p className="text-sm text-gray-600">{supportHours}</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HelpSupportDialog;
